import type { IconNode } from '../types';

/**
 * @name bull-head
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNyAxMGE1IDUgMCAwIDEtNC04IDQgNCAwIDAgMCA0IDRoMTBhNCA0IDAgMCAwIDQtNCA1IDUgMCAwIDEtNCA4IiAvPgogIDxwYXRoIGQ9Ik02LjQgMTVjLS4zLS42LS40LTEuMy0uNC0yIDAtNCAzLTMgMy03IiAvPgogIDxwYXRoIGQ9Ik0xMCAxMi41djEuNiIgLz4KICA8cGF0aCBkPSJNMTcuNiAxNWMuMy0uNi40LTEuMy40LTIgMC00LTMtMy0zLTciIC8+CiAgPHBhdGggZD0iTTE0IDEyLjV2MS42IiAvPgogIDxwYXRoIGQ9Ik0xNSAyMmE0IDQgMCAxIDAtMy02LjdBNCA0IDAgMSAwIDkgMjJaIiAvPgogIDxwYXRoIGQ9Ik05IDE4aC4wMSIgLz4KICA8cGF0aCBkPSJNMTUgMThoLjAxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bull-head
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bullHead: IconNode = [
  [
    'path',
    { d: 'M7 10a5 5 0 0 1-4-8 4 4 0 0 0 4 4h10a4 4 0 0 0 4-4 5 5 0 0 1-4 8', key: 'ug0tgo' },
  ],
  ['path', { d: 'M6.4 15c-.3-.6-.4-1.3-.4-2 0-4 3-3 3-7', key: '14148g' }],
  ['path', { d: 'M10 12.5v1.6', key: 'cb1pjl' }],
  ['path', { d: 'M17.6 15c.3-.6.4-1.3.4-2 0-4-3-3-3-7', key: '1cnrf4' }],
  ['path', { d: 'M14 12.5v1.6', key: 'asvv6d' }],
  ['path', { d: 'M15 22a4 4 0 1 0-3-6.7A4 4 0 1 0 9 22Z', key: 'tq98q4' }],
  ['path', { d: 'M9 18h.01', key: '2qx7s0' }],
  ['path', { d: 'M15 18h.01', key: 'pd7i4d' }],
];

export default bullHead;
